export default __webpack_public_path__ + "static/media/YAS0230.34I-27823_-16717_0.fcc26003.jpg";